import { render, staticRenderFns } from "./ProfileLeaderCard.vue?vue&type=template&id=30f090ec"
import script from "./ProfileLeaderCard.vue?vue&type=script&lang=js"
export * from "./ProfileLeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports